module.exports = __webpack_public_path__ + "img/premio-wm-ba.24d3782f.jpg";